import { readSessionStorage } from 'common/utils/StorageUtil'
import moment from 'moment'

const codes = {
    200: (res) => res,
    201: (res) => res,
    403: () => {
        throw new Error('Not Authorized')
    },
    404: () => {
        throw new Error('404 Not Found')
    },
    409: () => {
        throw new Error('409 Conflict')
    },
    429: () => {
        throw new Error('429 Too Many Requests')
    },
    500: () => {
        throw new Error('500 error')
    },
}

const checkStatus = (obj, response) => {
    if (!obj[`${response.status}`]) {
        throw new Error(`Unhandled Error during fetch${response.status}`)
    }
    return obj[`${response.status}`](response)
}

const checkAuth = (response, overrideStatus = {}) => {
    return checkStatus({
        ...codes,
        ...overrideStatus,
    }, response)
}

const checkError = (json = {}, errorCodeManagement = {}) => {
    if (json.error && errorCodeManagement[json.error]) {
        errorCodeManagement[json.error]()
    } else if (json.error) {
        throw new Error(json.error)
    }
    return json
}

const getJson = response => response.json()

const getAuthorization = () => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${readSessionStorage('aquaparc-token')}`,
    Module: 'WEB',
    // Mode: 'no-cors',
})

const aquaFetch = (url, options = {}, overrideStatus = {}) => {
    return fetch(url, {
        method: options.method ?? 'GET',
        body: options.body ? JSON.stringify(options.body) : undefined,
        headers: getAuthorization(),
        signal: options.signal,
    })
        .then(r => checkAuth(r, overrideStatus))
        .then(getJson)
        .then(checkError)
}

// Fonction pour convertir ArrayBuffer en hexadécimal
// const toHex = (buffer) => {
//     return Array.from(new Uint8Array(buffer))
//         .map(b => b.toString(16).padStart(2, '0'))
//         .join('')
// }

// // Convertir le salt (supposant qu'il est en hex ou base64)
// const getSaltBytes = (salt, encoder) => {
//     if (typeof salt !== 'string') return salt
//     if (!/^[0-9a-fA-F]+$/.test(salt)) return encoder.encode(salt)
//     return new Uint8Array(salt.match(/.{1,2}/g).map(byte => parseInt(byte, 16)))
// }

// Équivalent exact du code Java
// const generateHash = async (customer, salt) => {
//     const customerModified = customer + customer.split('').reverse().join('')

//     // Convertir les entrées
//     const encoder = new TextEncoder()
//     const customerBytes = encoder.encode(customerModified)
//     const saltBytes = getSaltBytes(salt, encoder)

//     // Importer la clé (le customer comme mot de passe)
//     const keyMaterial = await crypto.subtle.importKey(
//         'raw',
//         customerBytes,
//         'PBKDF2',
//         false,
//         ['deriveBits'],
//     )

//     // Dériver les bits avec PBKDF2-HMAC-SHA256
//     // 65536 itérations, 128 bits de sortie (comme dans le code Java)
//     const derivedBits = await crypto.subtle.deriveBits(
//         {
//             name: 'PBKDF2',
//             salt: saltBytes,
//             iterations: 65536,
//             hash: 'SHA-256',
//         },
//         keyMaterial,
//         128, // 128 bits
//     )

//     // Convertir en hexadécimal (équivalent du hex() en Java)
//     return toHex(derivedBits)
// }

const getExportAuthorization = async () => {
    const customer = 'aquaparc'
    const date = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
    return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readSessionStorage('aquaparc-token')}`,
        Module: 'WEB',
        'Request-Date': date,
        Customer: customer,
        Token: 'b5188d9a171bc80ed5ee517d7c489be0ddb48ec2feb41da652a682c45e62cd9f',
        // Mode: 'no-cors',
    }
}

const exportFetch = async (url, options = {}, overrideStatus = {}) => {
    const headers = await getExportAuthorization()
    return fetch(url, {
        method: options.method ?? 'GET',
        body: options.body ? JSON.stringify(options.body) : undefined,
        headers,
        signal: options.signal,
    })
        .then(r => checkAuth(r, overrideStatus))
}

export {
    aquaFetch,
    exportFetch,
    checkAuth,
}
